import React, { useEffect, useRef, useState } from 'react';
import './Science.css';
import imgAim from '../../assets/images/aim.jpeg';
import imgFocus from '../../assets/images/focus.jpeg';
import imgPartner from '../../assets/images/partner.jpeg';
import engine1 from '../../assets/images/engine/engine-1.png';
import EngineFlow from './EngineFlow';
import EngineFlowCompact from './EngineFlowCompact';
import Timeline from './Timeline';

export default function Science() {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(max-width: 1023px)');
    const handler = (e) => setIsCompact(e.matches);
    // initialize
    setIsCompact(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, []);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisible(true), 200);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="science" className="science-section" ref={containerRef} aria-labelledby="science-heading">
      <div className="science-container">
        <h2 id="science-heading" className="section-heading">Science</h2>
        <p className="lead">
          Engineering Differentiated ADC Therapeutics - at Styx, we design antibody–drug conjugates with precision and purpose.
          Our strategy integrates foundational pillars that drive differentiation, therapeutic index, and clinical relevance.
        </p>
        

        <div className={`pillars ${visible ? 'visible' : ''}`}>
          <article className="card" data-number="1" aria-labelledby="p1">
            <h4 id="p1">Tumor‑Selective Targeting</h4>
            <p>
              We engineer high‑affinity antibodies optimized for rapid internalization and deep tumor specificity. Our AI‑assisted
              AbRefine algorithm supports antibody humanization and optimization to enhance target engagement and developability.
            </p>
          </article>

          <article className="card" data-number="2" aria-labelledby="p2">
            <h4 id="p2">Optimized Linker - Payload Strategy</h4>
            <p>
              We leverage clinically validated payload classes integrated with cleavable linker technologies designed to balance
              systemic stability with efficient intracellular release — maximizing potency while preserving tolerability.
            </p>
          </article>

          <article className="card" data-number="3" aria-labelledby="p3">
            <h4 id="p3">Translationally Driven Design</h4>
            <p>
              Our development approach is guided by rigorous preclinical models that interrogate tumor heterogeneity, resistance biology,
              and delivery efficiency to ensure candidates are engineered for real‑world clinical performance.
            </p>
          </article>
        </div>


        <div className="engine-intro">
          <h3 className="engine-heading">Integrated Antibody Discovery Engine Enables Rapid ADC-Ready Lead Generation</h3>
          <p className="engine-subheading">Immediate program initiation and accelerated entry into new targets using a validated antibody pool and in-house capabilities</p>
        </div>

        {isCompact ? <EngineFlowCompact /> : <EngineFlow />}
        <Timeline styxPercent={30} tradPercent={95} />

      </div>
    </section>
  );
}

